import QubicaHeader from '@redturtle/qubicaamf-theme/components/Header/Header';

const Header = ({ pathname }) => {
  return <QubicaHeader />;
};

export default Header;
